import { updatePreset } from '@primeng/themes';

export function useMcxTheme() {
    updatePreset({
        semantic: {
            primary: {
                50: '{mcxGray.50}',
                100: '{mcxGray.100}',
                200: '{mcxGray.200}',
                300: '{mcxGray.300}',
                400: '{mcxGray.400}',
                500: '{mcxGray.500}',
                600: '{mcxGray.600}',
                700: '{mcxGray.700}',
                800: '{mcxGray.800}',
                900: '{mcxGray.900}',
                950: '{mcxGray.950}'
            },
            secondary: {
                50: '{mcxBlue.50}',
                100: '{mcxBlue.100}',
                200: '{mcxBlue.200}',
                300: '{mcxBlue.300}',
                400: '{mcxBlue.400}',
                500: '{mcxBlue.500}',
                600: '{mcxBlue.600}',
                700: '{mcxBlue.700}',
                800: '{mcxBlue.800}',
                900: '{mcxBlue.900}',
                950: '{mcxBlue.950}'
            },
            tertiary: {
                50: '{mcxRed.50}',
                100: '{mcxRed.100}',
                200: '{mcxRed.200}',
                300: '{mcxRed.300}',
                400: '{mcxRed.400}',
                500: '{mcxRed.500}',
                600: '{mcxRed.600}',
                700: '{mcxRed.700}',
                800: '{mcxRed.800}',
                900: '{mcxRed.900}',
                950: '{mcxRed.950}'
            },
            accent: {
                50: '{mcxGold.50}',
                100: '{mcxGold.100}',
                200: '{mcxGold.200}',
                300: '{mcxGold.300}',
                400: '{mcxGold.400}',
                500: '{mcxGold.500}',
                600: '{mcxGold.600}',
                700: '{mcxGold.700}',
                800: '{mcxGold.800}',
                900: '{mcxGold.900}',
                950: '{mcxGold.950}'
            }
        }
    })
}

export function useTealTheme() {
    updatePreset({
        semantic: {
            primary: {
                50: '{ppmTeal.50}',
                100: '{ppmTeal.100}',
                200: '{ppmTeal.200}',
                300: '{ppmTeal.300}',
                400: '{ppmTeal.400}',
                500: '{ppmTeal.500}',
                600: '{ppmTeal.600}',
                700: '{ppmTeal.700}',
                800: '{ppmTeal.800}',
                900: '{ppmTeal.900}',
                950: '{ppmTeal.950}'
            }
        }
    })
}

export function changeFontFamily(selectedFont: string) {
    updatePreset({
        semantic: {
            font: {
                family: selectedFont
            }
        }
    })
}

export function toggleDarkMode() {
    const element = document.querySelector('html');
    element?.classList.toggle('dark-mode');
}

// Legacy functions - these are now handled by ThemeService
// Keeping for backward compatibility
export function useMcxThemeLegacy() {
    useMcxTheme();
}

export function useTealThemeLegacy() {
    useTealTheme();
}